/**
 * Среда запуска: VK Mini App или обычный браузер (tech-spec §16.1–16.2).
 */
export type AppRuntimeKind = 'standalone_browser' | 'vk_mini_app';

export type DetectRuntimeResult = {
  kind: AppRuntimeKind;
};

/**
 * Грубая эвристика по параметрам запуска VK. При необходимости расширить (hash, родительский iframe).
 */
export function detectRuntime(): DetectRuntimeResult {
  if (typeof window === 'undefined') {
    return { kind: 'standalone_browser' };
  }
  const { search, hash } = window.location;
  if (/vk_app_id=/.test(search) || /vk_app_id=/.test(hash) || /vk_platform=/.test(search)) {
    return { kind: 'vk_mini_app' };
  }
  return { kind: 'standalone_browser' };
}
